import {Component} from 'preact';
import {pauseIcon} from '../../../constants/icons';
import {getCurrentTranslation} from '../../../../i18n/I18nResolver';

export default class MapPauseButton extends Component {
    onTogglePause = () => {
        const {togglePause} = this.props;
        if (togglePause) {
            togglePause(true);
        }
    };

    render() {
        const translations = getCurrentTranslation();
        const label = translations.mapControls.animationPause;

        return (
            <button
                className="map-controls__btn"
                onClick={this.onTogglePause}
                aria-label={label}
                aria-live="assertive"
            >
                {{...pauseIcon, props: {...pauseIcon.props, alt: label}}}
            </button>
        );
    }
}